import { jsx as _jsx } from "react/jsx-runtime";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box } from '@mui/material';
import { memo } from 'react';
import { ResponsiveIcon } from '../../icon/responsive';
const HideIndicator = memo(function HideIndicator(props) {
    const { onClick, show, ...styles } = props;
    return (_jsx(Box, { position: "absolute", bottom: 5, right: 5, bgcolor: "primary.dark", borderRadius: "50%", zIndex: 15, onClick: onClick, display: "flex", justifyContent: "center", alignItems: "center", p: 0.2, ...styles, children: show ? (_jsx(ResponsiveIcon, { Icon: Visibility, sx: { color: 'background.default', fontSize: '1em' } })) : (_jsx(ResponsiveIcon, { Icon: VisibilityOff, sx: { color: 'background.default', fontSize: '1em' } })) }));
});
export { HideIndicator };
